import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { Filter } from 'models';
import { Dictionary } from 'models';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { VendorService } from '#services/api/vendor.service';
import { ToasterService } from '#services/shared';
import { MatDialog } from '@angular/material/dialog';
import { VendorEditArgs, VendorEditDialogComponent } from '../vendor-edit-dialog/vendor-edit-dialog.component';
import { Role } from 'enums';
import { ConfirmationDialogComponent } from '#components/shared/confirmation-dialog/confirmation-dialog.component';
import { Page } from '_interfaces/page';

@Component({
  selector: 'app-vendor-table',
  templateUrl: './vendor-table.component.html',
  styleUrls: ['./vendor-table.component.scss'],
  standalone: false
})
export class VendorTableComponent implements OnInit {
  @Input()
  set filter(value: Filter) {
    this._filter = value;

    this.applyFilter(value);
  }
  get filter() {
    return this._filter;
  }

  @Input()
  set data(value: Dictionary[]) {
    this.dataSource.data = value;
  }

  @Input() columnsToDisplay: Map<string, string>;
  @Output() collectionChanged = new EventEmitter();

  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  @ViewChild(MatSort)
  set content(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  _filter: Filter = <Filter>{};
  dataSource = new MatTableDataSource<Dictionary>();

  Role = Role;

  constructor(
    public dialog: MatDialog,
    private vendorService: VendorService,
    private toaster: ToasterService
  ) { }

  ngOnInit() {
    setTimeout(() => this.dataSource.paginator = this.paginator);
  }

  get allColumns(): string[] {
    return Array.from(this.columnsToDisplay.keys());
  }

  get canShowTable() {
    const hasSearchedItems = this.filter.search
      ? this.dataSource.filteredData.length
      : true;

    const hasFilterParamsItems = this.filter.paramsCount
      ? this.dataSource.data.length
      : true;

    return hasSearchedItems && hasFilterParamsItems;
  }

  getColumnTitle(column: string): string {
    return this.columnsToDisplay.get(column);
  }

  applyFilter(filter: Filter) {
    this.dataSource.filter = filter.search;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  reloadSource(vendors: Dictionary[]) {
    this.data = vendors;
    this.dataSource.data = this.data;
  }

  async onEditVendor(vendor: Dictionary) {
    const args: VendorEditArgs = {
      vendor: vendor
    };
    const dialogRef = this.dialog.open(VendorEditDialogComponent, {
      width: '50%',
      maxHeight: '80%',
      data: args
    });

    dialogRef.afterClosed().subscribe(async (result: Dictionary) => {
      if (result) {
        const res = await this.vendorService.update(result).toPromise();
        this.collectionChanged.emit({ value: res });
        this.toaster.showSuccess('Success...', 'Vendor has been updated.');
      }
    });
  }

  onDeleteVendor(vendor: Dictionary) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      minWidth: '350px',
      minHeight: '200px',
      data: <Page>{
        pageTitle: 'Confirmation',
        pageDescription: `Are you sure you want to delete vendor "${vendor['Name']}"?`
      }
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        await this.vendorService.delete(vendor.ID).toPromise();
        this.collectionChanged.emit({ value: vendor });
        this.toaster.showSuccess('Success...', 'Vendor has been deleted.');
      }
    });
  }
}
